export default __webpack_public_path__ + "static/media/cancelSmall.87879731.svg";